import { Injectable } from '@angular/core';
import { UserService } from 'src/app/core/user.service';
import { ActionsEnum } from 'src/app/enums/permissions/actions.enum';
import { WidgetsService } from '../widgets/widgets.service';
import { Config } from 'src/app/config';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {

  constructor(public widgetsService: WidgetsService, public userService: UserService) {
    // Empty
  }

  public isAutosaveNeeded(): boolean {
    if (this.widgetsService.isPristine()) {
      return false;
    }
    if (!this.hasUserPermission(ActionsEnum.autosave)) {
      return false;
    }
    if (!this.formStatusAutoSaveEnabled()) {
      return false;
    }
    return true;
  }

  public formStatusAutoSaveEnabled(): boolean {
    // TODO: CHECK THE NAME
    // Version stored the latest version.
    const formStatusId = this.widgetsService.getLayoutRoot().version?.StatusId;

    // StatusId for Draft is 1
    if (formStatusId && (formStatusId === 1 || formStatusId === 3)) {
      return true;
    }
    return false;

  }

  public hasUserPermission(action: ActionsEnum): boolean {
    // For now only allow autosave if the user is an Admin
    // this will change in the future according to the permissions matrix defined.
    switch (action) {
      case ActionsEnum.autosave:
        if (this.userService.isAdmin()) {
          return true;
        }
        break;
      case ActionsEnum.editQuestion:
        //if (this.userService.isDeveloperUser()) {
        if (this.userService.isCTQuestionEditor()){
          return true;
        }
        break;
      case ActionsEnum.editFieldKey:
        if (this.userService.isCTQuestionEditor()) {
          return true;
        }
        break;
        case ActionsEnum.showQuestionBuilder:
          if (this.userService.isCTQuestionEditor()) {
            return true;
          }
        break;
        case ActionsEnum.updateQuestion:
          if (this.userService.isCTQuestionEditor() || this.userService.isCTFormReviewer() ) {
            return true;
          }
        break;
        case ActionsEnum.fieldWrapper:
          let isFieldKeyV = false;
          if (Config.FEATURES.get("isFieldKeyVisible")) {
            isFieldKeyV = Config.FEATURES.get("isFieldKeyVisible") as boolean;
          }
          if (this.userService.isCTQuestionEditor() && isFieldKeyV) {
            return true;
          }
        break;
    }

    return false;
  }

}
